const homePage = document.querySelector(".home");

if (homePage) {
  const dataEndOfTitle = document.getElementById("end-of-title");
  const headerContentContainer = document.getElementById(
    "header-content-container"
  );
  const headerTopRow = document.getElementById("header-top-row");
  const typeWriterHeading = document.getElementById("type-writer-heading");

  const computedStylesMargin = window.getComputedStyle(headerContentContainer);
  const computedStylesPadding = window.getComputedStyle(headerTopRow);

  function setH1LeftMargin() {
    let margin = computedStylesMargin.getPropertyValue("margin-left");
    let padding = computedStylesPadding.getPropertyValue("padding-left");
    if (margin > padding) {
      typeWriterHeading.style.left = margin;
    } else {
      typeWriterHeading.style.left = padding;
    }
  }

  window.addEventListener("resize", setH1LeftMargin);

  if (dataEndOfTitle) {
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const endings = dataEndOfTitle.dataset.endOfTitle.split(",");

    async function myTypeWriter() {
      for (let i = 0; i < endings.length; i++) {
        let phrase = endings[i];
        for (let j = 0; j < phrase.length; j++) {
          dataEndOfTitle.innerHTML += phrase.charAt(j);
          if (j == phrase.length - 1) {
            await delay(1000);
          } else {
            await delay(50);
          }
        }
        for (let k = phrase.length - 1; k >= 0; k--) {
          dataEndOfTitle.innerHTML = phrase.slice(0, k);
          await delay(50);
        }
      }
      setTimeout(myTypeWriter, 1000);
    }

    myTypeWriter();
  }

  setH1LeftMargin();
}
